/**
 * Header.jsx
 * Created by michaelbray on 6/16/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Subhead from './Subhead';

const propTypes = {
    title: PropTypes.string,
    headerClass: PropTypes.string,
    subheadItems: PropTypes.array
};

const defaultProps = {
    title: "RECREATION.GOV STYLE GUIDE",
    headerClass: "header-primary",
    subheadItems: []
};

export default class Header extends React.Component {
    render() {
        let subhead = null;
        if (this.props.subheadItems.length > 0) {
            subhead = <Subhead {...this.props} />;
        }

        return (
            <div>
                <section
                    className={`header-container ${this.props.headerClass}`}>
                    <div className="header">
                        <div className="header-left">
                            <h1 className="header-logo">
                                <Link to="/">{this.props.title}</Link>
                            </h1>
                        </div>
                    </div>
                </section>
                {subhead}
            </div>
        );
    }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
